var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsMultiSelectService, List } from './multiselect.service';
import { AddRowDirective } from '../../../../component/addrow/addrow.directive';
import { ValidationService } from '../../../../service/validation.service';
import { RequestQuery } from '../../../../component/list/list.service';
var KtsMultiSelectComponent = /** @class */ (function (_super) {
    __extends(KtsMultiSelectComponent, _super);
    function KtsMultiSelectComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.modalSubmit = new EventEmitter();
        _this.orgBelongsId = 0;
        _this.belongsId = 0;
        _this.belongs = [];
        _this.departmentId = 0;
        _this.department = [];
        _this.dispDepartment = [];
        _this.sectionId = 0;
        _this.section = {};
        _this.auName = '';
        _this.enableNameSearch = false;
        _this.dispSection = [];
        _this.targetDepartment = [];
        _this.recs = [];
        _this.retirees = []; // ログイン無効ユーザ
        _this.select = [];
        _this.items = [];
        _this.addRec = {};
        _this.readonly = false;
        _this.baseUrl = '/v1/gen/au-profile-api';
        _this.service.init();
        return _this;
    }
    KtsMultiSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
        this.getSearchItem();
        if (this.cols.length > 0) {
            if (!this.cols[0].readonly) {
                this.getList();
                this.getRetiree();
            }
            if (this.cols[0].readonly) {
                this.readonly = true;
            }
            if (this.cols[0].items) {
                this.getAddCols(this.cols[0].items);
            }
        }
        this.setCompRec();
    };
    KtsMultiSelectComponent.prototype.getSearchItem = function () {
        var _this = this;
        this.belongs = [];
        this.orgBelongsId = jsonpath.value(this.component, '$.params.belongs') || null;
        if (!this.orgBelongsId) {
            var query = Object.assign(new RequestQuery(), { limit: '', predicateList: [{ name: 'key', value: '3', operator: 'ne' }] });
            this.service.getType('AU_BELONGS', query).subscribe(function (rec) {
                if (rec instanceof Array) {
                    _this.belongs = rec;
                }
            });
        }
        else {
            this.belongsId = this.orgBelongsId;
        }
        if (!this.orgBelongsId || this.orgBelongsId === 1) {
            this.service.setBaseUrl('/v1/gen/department-m-service?query={"orderByList":[{"name":"id","direction":"asc"}]}');
            this.service.getRecord().subscribe(function (rec) {
                var departmentOptions = [];
                var dispDepartmentOptions = [];
                var sectionOptions = {};
                var dispSectionOptions = [];
                for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    departmentOptions.push({ code: item.id, display: item.department_name });
                    dispDepartmentOptions.push({ code: item.id, display: item.display_department_name });
                    sectionOptions[item.id] = [];
                    _this.service.sortItems(item.section_m);
                    for (var _b = 0, _c = item.section_m; _b < _c.length; _b++) {
                        var sec = _c[_b];
                        sectionOptions[item.id].push({ code: sec.id, display: sec.section_name });
                        dispSectionOptions.push({ code: sec.id, display: sec.display_section_name });
                    }
                }
                _this.department = departmentOptions;
                _this.dispDepartment = dispDepartmentOptions;
                _this.section = sectionOptions;
                _this.dispSection = dispSectionOptions;
            });
        }
    };
    KtsMultiSelectComponent.prototype.getList = function () {
        var _this = this;
        this.recs = [];
        var url = this.baseUrl;
        var type = jsonpath.value(this.component, '$.params.getType') || null;
        if (type === 'sales_member') {
            // 営業担当
            url += '?query={"predicateList":[{"name":"is_sales_member","value":"true","operator":"eq"}]}';
            this.enableNameSearch = true;
        }
        else if (type === 'technology_member') {
            // 技術・スタッフ担当
            url += '?query={"predicateList":[{"name":"is_technology_member","value":"true","operator":"eq"}]}';
            this.enableNameSearch = true;
        }
        else if (type === 'is_project_note' || type === 'is_construction_note') {
            // 連絡メモ
            this.getId();
            var belongs = '';
            if (this.orgBelongsId) {
                belongs = ',{"name":"belongs","value":"' + this.orgBelongsId + '","operator":"eq"}';
            }
            url = '/v1/gen/au-profile-note-api?query={"predicateList":[{"name":"' + type + '","value":"' + this.id + '","operator":"eq"},{"name":"au_m.status","value":"2","operator":"ne"}' + belongs + ']}';
        }
        else if (this.orgBelongsId) {
            url += '?query={"predicateList":[{"name":"belongs","value":"' + this.orgBelongsId + '","operator":"eq"}]}';
        }
        else {
            url += '?query={"predicateList":[{"name":"belongs","value":"3","operator":"ne"}]}';
        }
        var nameSearch = jsonpath.value(this.component, '$.params.nameSearch') || null;
        if (nameSearch != null) {
            this.enableNameSearch = nameSearch;
        }
        this.service.setBaseUrl(url);
        this.service.getRecord().subscribe(function (rec) {
            _this.recs = rec.items || [];
        });
    };
    KtsMultiSelectComponent.prototype.getId = function () {
        var url = window.location.href;
        var result = url.match(/\/view\/(\d+)/);
        this.id = result[1];
    };
    KtsMultiSelectComponent.prototype.getRetiree = function () {
        var _this = this;
        var url = this.baseUrl;
        url += '?query={"predicateList":[{"name":"au_m.status","value":"2","operator":"eq"}]}';
        this.service.setBaseUrl(url);
        this.service.getRecord().subscribe(function (rec) {
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                _this.retirees.push(item.xuid);
            }
        });
    };
    KtsMultiSelectComponent.prototype.getAddCols = function (cols) {
        this.addRec = {};
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.hidden && col.key && col.params && typeof col.params.initValue !== 'undefined') {
                this.addRec[col.key] = col.params.initValue;
            }
        }
    };
    KtsMultiSelectComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.modal = this.remodalElement.nativeElement;
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var self = this;
        this.element = this.multiSelectElement.nativeElement;
        this.select = [];
        $(this.element).multiSelect({
            afterInit: function (ms) {
                var selectableSearchString = '#' + this.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                $(selectableSearchString).hide();
                if (self.belongsId === 0) {
                    $(selectableSearchString).show();
                }
                else if (self.belongsId === 1) {
                    if (self.departmentId > 0 || self.auName) {
                        for (var _i = 0, _a = self.targetDepartment; _i < _a.length; _i++) {
                            var target = _a[_i];
                            if (self.retirees.indexOf(target) < 0) {
                                $(selectableSearchString + '[data-xuid="' + target + '"][data-belongs="1"]').show();
                            }
                        }
                    }
                    else {
                        for (var _b = 0, _c = self.recs; _b < _c.length; _b++) {
                            var rec = _c[_b];
                            if (self.retirees.indexOf(rec.xuid) < 0) {
                                $(selectableSearchString + '[data-xuid="' + rec.xuid + '"][data-belongs=' + self.belongsId + ']').show();
                            }
                        }
                    }
                }
                else {
                    $(selectableSearchString + '[data-belongs=' + self.belongsId + ']').show();
                }
            },
            afterSelect: function (values) {
                if (values && values[0]) {
                    self.select.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.select.indexOf(values[0]);
                    if (idx >= 0) {
                        self.select.splice(idx, 1);
                    }
                }
                $(self.element).multiSelect('refresh');
            }
        });
        this.multiSelectOptions.changes.subscribe(function (t) {
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectComponent.prototype.onChangeAuName = function (e) {
        this.auName = e.target.value;
    };
    KtsMultiSelectComponent.prototype.onChangeBelongs = function (e) {
        this.belongsId = parseInt(e.target.value);
        this.departmentId = 0;
        this.sectionId = 0;
        this.targetDepartment = [];
        $(this.element).multiSelect('refresh');
    };
    KtsMultiSelectComponent.prototype.onChangeDepartment = function (e, key) {
        var _this = this;
        if (key === 'department') {
            this.departmentId = parseInt(e.target.value);
            this.sectionId = 0;
        }
        else if (key === 'section') {
            this.sectionId = parseInt(e.target.value);
        }
        if (this.departmentId === 0 && !this.auName) {
            this.targetDepartment = [];
            $(this.element).multiSelect('refresh');
            return;
        }
        var departmentPred = '';
        if (this.departmentId !== 0) {
            departmentPred = ',{"name":"department_m.id","value":"' + this.departmentId + '","operator":"eq"}';
        }
        var sectionPred = '';
        if (this.sectionId !== 0) {
            sectionPred = ',{"name":"section_m.id","value":"' + this.sectionId + '","operator":"eq"}';
        }
        var auNamePred = '';
        if (this.auName) {
            auNamePred = ',{"name":"au_name","value":"' + this.auName + '","operator":"eq"}';
        }
        this.service.setBaseUrl(this.baseUrl + '?query={"predicateList":[{"name":"belongs","value":"1","operator":"eq"}' + departmentPred + sectionPred + auNamePred + ']}');
        this.service.getRecord().subscribe(function (rec) {
            var targets = [];
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                targets.push(item.xuid);
            }
            _this.targetDepartment = targets;
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsMultiSelectComponent.prototype.onSubscribe = function (data) {
        this.select = [];
        this.items = [];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array) {
            this.items = data[this.cols[0].key];
        }
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            else {
                item.$type = "post" /* Post */;
            }
            this.select.push(item.au_m_xuid.toString());
        }
        this.onCancel();
        this.setCompRec();
    };
    KtsMultiSelectComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm' || (this.cols.length > 0 && this.cols[0].readonly)) {
            this.readonly = true;
        }
    };
    KtsMultiSelectComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#open') {
            this.onCancel();
            this.remodal.open();
        }
    };
    KtsMultiSelectComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsMultiSelectComponent.prototype.onCancel = function () {
        this.auName = '';
        $(this.element).multiSelect('deselect_all');
        var select = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type !== "delete" /* Delete */) {
                select.push(item.au_m_xuid.toString());
            }
        }
        $(this.element).multiSelect('select', select);
        this.select = select;
        this.belongsId = this.orgBelongsId ? this.orgBelongsId : 0;
        this.departmentId = 0;
        this.sectionId = 0;
        this.targetDepartment = [];
        $(this.element).multiSelect('refresh');
    };
    KtsMultiSelectComponent.prototype.onSubmit = function () {
        this.auName = '';
        this.setItems();
        this.addError();
        this.setCompRec();
        this.remodal.close();
    };
    KtsMultiSelectComponent.prototype.setItems = function () {
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var i = items.length - 1; i >= 0; i--) {
            if (typeof items[i].id === 'undefined') {
                items.splice(i, 1);
            }
            else {
                items[i].$type = "delete" /* Delete */;
            }
        }
        for (var _i = 0, _a = this.select; _i < _a.length; _i++) {
            var s = _a[_i];
            var rec = new List();
            for (var _b = 0, _c = this.recs; _b < _c.length; _b++) {
                var r = _c[_b];
                if (s === r.xuid.toString()) {
                    rec = r;
                    break;
                }
            }
            var add = true;
            for (var _d = 0, items_1 = items; _d < items_1.length; _d++) {
                var item = items_1[_d];
                if (item.au_m_xuid === rec.xuid) {
                    add = false;
                    item.$type = "put" /* Put */;
                }
            }
            if (add) {
                items.push({
                    $type: "post" /* Post */,
                    au_m_xuid: rec.xuid,
                    belongs: rec.belongs,
                    department: rec.department,
                    department_m_id: rec.department_m_id,
                    section_m_id: rec.section_m_id,
                    sei: rec.sei,
                    mei: rec.mei
                });
            }
        }
        this.items = items;
    };
    KtsMultiSelectComponent.prototype.setCompRec = function () {
        var data = {};
        var items = JSOG.parse(JSON.stringify(this.items));
        if (Object.keys(this.addRec).length > 0) {
            for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                var item = items_2[_i];
                Object.assign(item, this.addRec);
            }
        }
        for (var _a = 0, items_3 = items; _a < items_3.length; _a++) {
            var item = items_3[_a];
            delete item.sei;
            delete item.mei;
            delete item.belongs;
            delete item.department;
            delete item.department_m_id;
            delete item.section_m_id;
        }
        data[this.cols[0].key] = items;
        this.action.setCompRec(this.componentName, data);
    };
    KtsMultiSelectComponent.prototype.addError = function () {
        if (this.cols[0].required && this.dir) {
            var items = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type === "delete" /* Delete */) {
                    continue;
                }
                items.push(item);
            }
            var errFlg = (items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
            this.validService.afterValidation();
        }
    };
    KtsMultiSelectComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    KtsMultiSelectComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-multiselect',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n      </dl>\n    </div>\n  </div>\n  <div addrowDir></div>\n  <div class=\"row -mt-1\" *ngIf=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <btn\n          [componentName]=\"componentName + '#Button'\"\n          [component]=\"{\n            params: {\n              buttons: [{\n                type: 'button',\n                event: componentName + '#open',\n                caption: (msg | async)['Button_select']\n              }]\n            }\n          }\"></btn>\n    </div>\n  </div>\n  <div class=\"row\" [class.-mt-1]=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <div class=\"tableWrapper\" id=\"{{ componentName + '#List' }}\">\n        <table class=\"tableWrapper_table\">\n          <thead>\n          <tr data-href=\"#\">\n            <th style=\"width:20%\" *ngIf=\"!orgBelongsId\"><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.belongs'] }}</a></th>\n            <th style=\"width:20%\"><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.department'] }}</a></th>\n            <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.name'] }}</a></th>\n          </tr>\n          </thead>\n          <tbody>\n          <ng-template ngFor let-item [ngForOf]=\"items\">\n            <tr *ngIf=\"item.$type !== 'delete'\" data-href=\"#\">\n              <td *ngIf=\"!orgBelongsId\">\n                <column-formlabel [col]=\"{controlType: 'select', params: {options: belongs}}\" [val]=\"item.belongs\"></column-formlabel>\n              </td>\n              <td>\n                <column-formlabel *ngIf=\"item.belongs === 1 && item.department_m_id && item.section_m_id\" [col]=\"{controlType: 'select', params: {options: dispSection}}\" [val]=\"item.section_m_id\"></column-formlabel>\n                <column-formlabel *ngIf=\"item.belongs === 1 && item.department_m_id && !item.section_m_id\" [col]=\"{controlType: 'select', params: {options: dispDepartment}}\" [val]=\"item.department_m_id\"></column-formlabel>\n                <column-formlabel *ngIf=\"item.belongs > 1\" [col]=\"{}\" [val]=\"item.department\"></column-formlabel>\n              </td>\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"item.sei + ' ' + item.mei\"></column-formlabel>\n              </td>\n            </tr>\n          </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelect' }}\" #remodal>\n    <div class=\"remodal_whitebg\">\n      <p *ngIf=\"component.title\" class=\"sectionHeading\">{{ component.title }}</p>\n      <div class=\"ms-container_divisionWrapper\">\n        <ng-template [ngIf]=\"enableNameSearch\">\n          <div class=\"row -mb-1\">\n            <div class=\"col-sm-6\"></div>\n            <div class=\"col-sm-4\">\n              <input type=\"text\" class=\"formInputText\" placeholder=\"{{(msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.name']}}\" [value]=\"auName\" (change)=\"onChangeAuName($event)\">\n            </div>\n            <div class=\"col-sm-2\">\n              <item-btn [key]=\"'btn'\" [btn]=\"{\n                type: 'button',\n                event: componentName + '#search',\n                caption: (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.search']\n              }\" (click)=\"onChangeDepartment($event, 'auName')\"></item-btn>\n            </div>\n          </div>\n        </ng-template>\n        <p *ngIf=\"!orgBelongsId\" class=\"ms-container_division\">\n          <select (change)=\"onChangeBelongs($event)\">\n            <option value=\"0\" [selected]=\"belongsId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.select.belongs'] }}</option>\n            <option *ngFor=\"let option of belongs\" [value]=\"option.code\" [selected]=\"belongsId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n        <ng-template [ngIf]=\"belongsId === 1\">\n          <p class=\"ms-container_division\">\n            <select (change)=\"onChangeDepartment($event, 'department')\">\n              <option value=\"0\" [selected]=\"departmentId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.select.dispDepartment'] }}</option>\n              <option *ngFor=\"let option of department\" [value]=\"option.code\" [selected]=\"departmentId.toString() === option.code\">{{ option.display }}</option>\n            </select>\n          </p>\n          <p class=\"ms-container_division\">\n            <select (change)=\"onChangeDepartment($event, 'section')\">\n              <option value=\"0\" [selected]=\"sectionId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectComponent.select.section'] }}</option>\n              <option *ngFor=\"let option of section[departmentId]\" [value]=\"option.code\" [selected]=\"sectionId.toString() === option.code\">{{ option.display }}</option>\n            </select>\n          </p>\n        </ng-template>\n      </div>\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelect>\n          <option *ngFor=\"let option of recs\" [value]=\"option.xuid\" [attr.data-xuid]=\"option.xuid\" [attr.data-belongs]=\"option.belongs\" #multiSelectOptions>\n            <ng-template [ngIf]=\"!orgBelongsId\">\n              <column-formlabel [col]=\"{controlType: 'select', params: {options: belongs}}\" [val]=\"option.belongs\"></column-formlabel>\n              <label>{{ (option.belongs ? ' / ' : '') }}</label>\n            </ng-template>\n            <ng-template [ngIf]=\"option.belongs === 1\">\n              <column-formlabel *ngIf=\"option.department_m_id && option.section_m_id\" [col]=\"{controlType: 'select', params: {options: dispSection}}\" [val]=\"option.section_m_id\"></column-formlabel>\n              <column-formlabel *ngIf=\"option.department_m_id && !option.section_m_id\" [col]=\"{controlType: 'select', params: {options: dispDepartment}}\" [val]=\"option.department_m_id\"></column-formlabel>\n              <label>{{ (option.department_m_id ? ' / ' : '') }}</label>\n            </ng-template>\n            <label *ngIf=\"option.belongs > 1\">{{ (option.department ? (option.department + ' / ') : '') }}</label>\n            <label>{{ option.sei + ' ' + option.mei }}</label>\n          </option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMultiSelectComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsMultiSelectService },
        { type: ValidationService }
    ]; };
    KtsMultiSelectComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }],
        multiSelectElement: [{ type: ViewChild, args: ['multiSelect',] }],
        multiSelectOptions: [{ type: ViewChildren, args: ['multiSelectOptions',] }],
        dir: [{ type: ViewChild, args: [AddRowDirective,] }]
    };
    return KtsMultiSelectComponent;
}(ContentBaseComponent));
export { KtsMultiSelectComponent };
//# sourceMappingURL=multiselect.component.js.map